import { ButtonHTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

const variants = {
    regular: 'border-0 gap-2 rounded-3xl',
    circle: 'rounded-full',
} satisfies Record<string, string>

const themes = {
    primary:
        'bg-brand text-white hover:brightness-110 active:bg-green-700 disabled:bg-neutral-300',
    green: 'bg-green-300 text-green-700 hover:brightness-110 active:brightness-90',
    'black-on-white':
        'bg-white text-primary hover:brightness-110 active:brightness-90',
} satisfies Record<string, string>

const sizes = {
    default: 'h-11 px-4 font-bold text-base/5',
    small: 'h-9 px-4 font-bold text-sm/5',
    icon: 'h-10 w-10 px-0 justify-center',
} satisfies Record<string, string>

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    readonly block?: boolean
    readonly centering?: boolean
    readonly variant?: keyof typeof variants
    readonly theme?: keyof typeof themes
    readonly size?: keyof typeof sizes
}

function Button({
    block,
    centering,
    variant = 'regular',
    theme = 'primary',
    size = 'default',
    className,
    ...props
}: ButtonProps): JSX.Element {
    return (
        <button
            {...props}
            className={twMerge(
                'flex flex-row high',
                'px-4',
                'items-center',
                'transition-all',
                'disabled:pointer-events-none',
                block && 'w-full',
                centering && 'justify-center',
                variants[variant],
                themes[theme],
                sizes[size],
                className
            )}
        />
    )
}

export { Button }
